export function addClass(
  element: string | Element,
  className: string,
  parent?: Element
) {
  if (typeof element === 'object') {
    return element.classList.add(className);
  }
  const targetParent = parent || document;
  targetParent.querySelector(element)?.classList.add(className);
}

export function removeClass(
  element: string | Element,
  className: string,
  parent?: Element
) {
  if (typeof element === 'object') {
    return element.classList.remove(className);
  }
  const targetParent = parent || document;
  targetParent.querySelector(element)?.classList.remove(className);
}

export function toggleClass(
  element: string | Element,
  className: string,
  parent?: Element
) {
  if (typeof element === 'object') {
    return element.classList.toggle(className);
  }
  const targetParent = parent || document;
  targetParent.querySelector(element)?.classList.toggle(className);
}
